import { getJwtToken } from './getJwtToken';

export interface IJitsi {
  getJwtToken: typeof getJwtToken;
}

/**
 * @namespace
 */
const Jitsi: IJitsi = {
  getJwtToken,
};

export default Jitsi;
